import React, { PropsWithChildren } from 'react';

import { Notifications } from './components';

const withGlobalNotifications = (Component: React.FC<PropsWithChildren<any>>): React.FC<PropsWithChildren<any>> => ({
  children,
  ...props
}: PropsWithChildren<any>): JSX.Element => (
  <Component {...props}>
    <Notifications />
    {children}
  </Component>
);

export default withGlobalNotifications;
